/* eslint-disable class-methods-use-this, no-unused-vars, import/prefer-default-export */
import { AnalyticsProvider, UserTraits } from "../types";

declare global {
  interface Window {
    posthog?: {
      identify(userId: string, traits?: Record<string, any>): void;
      capture(event: string, properties?: Record<string, any>): void;
      reset(): void;
      people?: {
        set(properties: Record<string, any>): void;
      };
    };
  }
}

export class PostHogProvider implements AnalyticsProvider {
  name = "posthog";

  identify(userId: string, traits?: UserTraits): void {
    window.posthog?.identify(userId, traits);
  }

  track(event: string, properties?: Record<string, any>): void {
    window.posthog?.capture(event, properties);
  }

  page(name?: string, properties?: Record<string, any>): void {
    window.posthog?.capture("$pageview", { page_name: name, ...properties });
  }

  reset(): void {
    window.posthog?.reset();
  }

  setUserProperties(properties: Record<string, any>): void {
    window.posthog?.people?.set(properties);
  }
}
